import React, { useState } from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
import { Button } from "@/aible";
import { useDispatch } from "@/types/store";
import { removeFocusedDataset, getLinkedComparisonProjects } from "@/containers/Next/NextReducer";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import * as globalReducer from "@/containers/App/reducer";
import { Alert } from "react-bootstrap";
const DashboardRemoveFocusModal = ({ id, open, chart, handleClose }) => {
    const dispatch = useDispatch();
    const isRemoving = useSelector((state) => globalReducer.getIsCreatingFocusedDataset(state));
    const [isRemovingStarting, updateIsRemovingStarting] = useState(false);
    const linkedComparisonProjects = useSelector((state) => getLinkedComparisonProjects(state, id)) ?? {};
    let title = chart?.title;
    if (Object.keys(linkedComparisonProjects ?? {}).length > 0 && linkedComparisonProjects["@_Original_@"] != id) {
        const foundPair = Object.entries(linkedComparisonProjects).find(([key, nextId]) => nextId == id);
        if (foundPair !== undefined) {
            title = `${foundPair[0]} and ${title}`;
        }
    }
    if (!chart) {
        return null;
    }
    const handleRemoveDataset = async () => {
        try {
            updateIsRemovingStarting(true);
            setTimeout(() => {
                handleClose();
                updateIsRemovingStarting(false);
            }, 2000);
            await dispatch(removeFocusedDataset(chart));
        }
        catch (error) {
            console.error("Error removing focused dataset:", error);
            toast(React.createElement("div", null, "There was an error removing your focused project. Please contact aible support if this issue persists."), {
                type: toast.TYPE.ERROR,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 7500
            });
            updateIsRemovingStarting(false);
        }
    };
    const onOpenChange = () => {
        if (!isRemoving) {
            handleClose();
        }
    };
    return (React.createElement(Dialog, { open: open, onOpenChange: () => onOpenChange() },
        React.createElement(DialogContent, { showCloseButton: isRemoving },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Remove What's Changed Evaluation?")),
            React.createElement(Alert, { bsStyle: "warning" },
                React.createElement("strong", null, "Caution: "),
                " Would you like to remove an analysis focused on what changed when the",
                " ",
                React.createElement("strong", null, title),
                "?"),
            React.createElement("div", null,
                "Your current report ",
                React.createElement("strong", null, "will not be lost"),
                ". For larger datasets, this process may take a few minutes."),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { type: "primary", onClick: () => handleRemoveDataset(), disabled: isRemoving || isRemovingStarting, isLoading: isRemoving || isRemovingStarting }, "Remove Focused Analysis"),
                React.createElement(Button, { type: "secondary", onClick: () => onOpenChange(), disabled: isRemoving }, "Cancel")))));
};
export default DashboardRemoveFocusModal;
